module.exports = __webpack_public_path__ + "img/tip.c345f973.png";